export default __webpack_public_path__ + "static/testimonial-photo-1-af2e908581dec718b0ff9f06dc487dee.jpeg";